// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import DominicanRepublic from '../_raw/flag/icon_flag_dominican_republic.png';

export default () => <img src={DominicanRepublic} alt="DominicanRepublic" />;
